import {Component, OnInit} from '@angular/core';
import {DatePipe} from "@angular/common";
import {AcompanhamentoService} from "./services/acompanhamento.service";
import {MessageService} from "./core/services/message.service";
import {GovBrService} from "./services/govbr.service";

@Component({
    selector: 'dev-root',
    templateUrl: 'dev-component.html',
})

export class DevComponent implements OnInit {

    constructor(private acompanhamentoService: AcompanhamentoService,
                private messageService: MessageService,
                private govBrService: GovBrService) { }

    ngOnInit(): void {
    }
}
